/*
 * @Description:
 * @LastEditors: Please set LastEditors
 * @Date: 2020-11-03 09:41:19
 */
import axios from 'axios';
import qs from 'qs';
import store from '@/store/index';
import router from '@/router/index';
import Config from '@/config/index';
import { Notification, Loading, MessageBox } from 'element-ui';
// import cancelDuplicateRequest from './request.cancel';
const ajaxWhileList = ['/login/auth'];
let loginError = [];
let serviceLoading = null; // loading实例
/**
 * @description: 清除loading
 * @param {object} loading 实体
 */
const cleanLoading = loading => {
  try {
    if (loading) {
      loading.close();
      loading = null;
    }
  } catch (e) {
    console.error(e);
  }
};
let isHasMustSign = false; // 是否强制去签约，true则不在处理后续请求
const service = axios.create({
  baseURL: '', // 以config中的为准， 有些img与资源也需要使用统配路径
  timeout: 1000 * 60 * 5, // request timeout
  headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } //multipart/form-data application/json;charset=UTF-8
});
service.interceptors.request.use(
  /**
   * @description: 请求配置
   * @param {Object} yapi yapi前缀地址 notUseQs是否使用stringify btnLoading是否设置全局按钮加载状态
   * @return {Object} config
   */
  config => {
    // cancelDuplicateRequest(config, config.url);
    if (config.url != 'http://stream.yxvzb.com/Api/YiYang/addVideos') {
      config.headers[Config.token] = localStorage[Config.token] || '';
    }
    // 修改为YAPI路径,根据config.yapi来补齐yapi地址
    if (config.yapi && process.env.NODE_ENV !== 'production') {
      config.url = `http://yapi.jimijiayuan.cn/mock/${config.yapi}${config.url}`;
    }
    // set btn loading
    try {
      if ((config.data && config.data.btnLoading) || config.btnLoading) {
        store.commit('SET_BTLOADING', true);
      }
    } catch (e) {
      console.error(e);
    }
    if (config.serviceLoading) {
      serviceLoading = Loading.service({ fullscreen: true });
    }
    // 合并项目结算中全局参数
    try {
      if (config.data) {
        Object.assign(config.data, store.state.projectSettled.request);
      }
    } catch (e) {
      console.error('request config err:', e);
    }
    if (
      config.method === 'post' &&
      ![
        '/rest/cso/saas/upload/image',
        '/rest/cso/saas/upload/fileUploadProjectBI'
      ].includes(config.url) &&
      !config.notUseQs
    ) {
      config.data = qs.stringify(config.data);
    }
    return config;
  },
  error => {
    // Do something with request error // for debug
    Promise.reject(error);
  }
);

// respone interceptor
service.interceptors.response.use(
  /**
   * @description: 响应配置
   * @param {Object} noInterceptor 是否使用拦截逻辑, config下自定义字段要使用config下的，不要使用config.data中的，兼容处理。
   * @return {Object} config
   */
  async response => {
    // 有必须签约则不在处理后续接口
    if (isHasMustSign) {
      return Promise.reject(`isHasMustSign: ${isHasMustSign}`);
    }
    let { data: respData, config: respConfig } = response;

    respConfig.serviceLoading && cleanLoading(serviceLoading);
    if (
      ajaxWhileList.indexOf(respConfig.url) != -1 ||
      (respConfig.method !== 'post' &&
        respConfig.data &&
        respConfig.data.includes('noInterceptor')) ||
      respConfig.noInterceptor
    ) {
      return response;
    } else {
      if (
        respData.returnCode == 501 ||
        respData.status == 500 ||
        respData.status == -999
      ) {
        localStorage.clear();
        router.push({
          name: 'login'
        });
        if (loginError.length) {
          return false;
        } else {
          loginError.push(1);
          Notification({
            title: '失败',
            message: '登陆过期，请重新登陆',
            type: 'error'
          });
          setTimeout(() => {
            location.reload();
          }, 400);
        }
      } else {
        // 强制签约
        if (respData.status == '-900') {
          isHasMustSign = true;
          try {
            await MessageBox.confirm(respData.message, '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              showClose: false
            });
            const toPath = '/contract/supplier';
            if (router.app.$route.path === toPath) {
              window.location.reload();
            } else {
              router.push({
                path: toPath
              });
            }
          } catch (e) {
            console.error(e);
          }
          isHasMustSign = false;
          return Promise.reject(respData);
        }
        // 用户监管状态为停用
        if (respData.code == '-901') {
          MessageBox.confirm(
            `${respData.data.join(
              '、'
            )}参与人数据监测不合格，系统已自动拦截无法提交结算`,
            '提示',
            {
              confirmButtonText: '确定',
              showCancelButton: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              showClose: false
            }
          );
          return Promise.reject(respData);
        }
        if (respData.code == '-100') {
          MessageBox.confirm(respData.message, '提示', {
            confirmButtonText: '关闭',
            showCancelButton: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false
          });
          return Promise.reject(respData);
        }
        if ((respData.status && respData.status == 1) || respData.code == 200) {
          store.commit('SET_BTLOADING', false);
          // 就这样吧 修改影响太大 艹
          // 添加了pdata
          return { ...response, pdata: respData.data };
        } else if (respData.status === undefined) {
          // 文件下载无status
          return response;
        } else {
          if (!respConfig.noNotification) {
            let msg = respData.message || respData.returnMsg || '服务器异常';
            Notification({
              title: '失败',
              message: `${msg}`,
              type: 'error'
            });
          }
          store.commit('SET_BTLOADING', false);
          return Promise.reject(respData);
        }
      }
    }
  },
  error => {
    store.commit('SET_BTLOADING', false);
    Notification({
      title: '失败',
      message: '网络出现错误请您检查网络情况',
      type: 'error'
    });
    return Promise.reject(error);
  }
);
export default service;
